/** CE logo hex glyph: mirrors badge_svg.py seal mark. */
export function CeHexGlyph({
  dotClassName,
  size = 22,
}: {
  dotClassName: string;
  /** Render size in px: trust-page hero uses ~22–24; embed SVG is ~15px at 26px badge height. */
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="8 4 18 18"
      aria-hidden
      className="shrink-0"
    >
      <defs>
        <clipPath id="ce-trust-hex-clip">
          <polygon points="17,5.5 23.5,9.25 23.5,16.75 17,20.5 10.5,16.75 10.5,9.25" />
        </clipPath>
      </defs>
      <polygon
        points="17,5.5 23.5,9.25 23.5,16.75 17,20.5 10.5,16.75 10.5,9.25"
        fill="#e6a98c"
      />
      <g clipPath="url(#ce-trust-hex-clip)" stroke="#1a1a1a" strokeWidth="0.65" opacity="0.9">
        <line x1="4" y1="9" x2="30" y2="2" />
        <line x1="4" y1="13" x2="30" y2="6" />
        <line x1="4" y1="17" x2="30" y2="10" />
        <line x1="4" y1="9" x2="30" y2="16" />
        <line x1="4" y1="13" x2="30" y2="20" />
        <line x1="4" y1="17" x2="30" y2="24" />
      </g>
      <circle cx="21.6" cy="17.1" r="2.2" className={dotClassName} stroke="#1a1a1a" strokeWidth="0.6" />
    </svg>
  );
}
